function documentFragmentToHTML(document, fragment) {
  // make new element, insert document fragment, then get innerHTML!
  var div = document.createElement("div");
  div.appendChild(fragment.cloneNode(true));

  // your document fragment to a string (w/ html)! (yay!)
  return div.innerHTML;
}

function documentFragmentToString(document, fragment) {
  // make new element, insert document fragment, then get innerHTML!
  var div = document.createElement("div");
  div.appendChild(fragment.cloneNode(true));

  // your document fragment to a string (w/ html)! (yay!)
  return div.innerText.trim();
}

export { documentFragmentToHTML, documentFragmentToString };
